export default "__VITE_ASSET__BZySZxMK__"